import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "../charts/DashBoardResultSetUtil";
import {prepareChartData} from "./HighChartsDrawer";
import {calcChartTitle} from "./HighGaugeDrawer";
import {addLinkOptionsToPoint, handleChartClick} from "./HighPieChartDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighColumnRangeChart(userDashboardChartLine, h, w, widget, Highcharts) {
    let params = userDashboardChartLine.parameters;
    let xCateg = params[DashboardConstants.Param_XCategory];
    let categs = [];
    let rangeFrom = params[DashboardConstants.Param_RangeFrom];
    let rangeTo = params[DashboardConstants.Param_RangeTo];
    let yAxisTitle = params[DashboardConstants.Param_Title];
    let points = [];
    let list = userDashboardChartLine.resultSet;
    for (let i = 0; i < resultSetSize(list); i++) {
        categs[i] = getByColName(i, xCateg, list);
        let rangeFromNum = parseFloat(getByColName(i, rangeFrom, list));
        let rangeToNum = parseFloat(getByColName(i, rangeTo, list));
        points[i] = {x: rangeFromNum, y: rangeToNum};
        addLinkOptionsToPoint(params, list, i, points[i]);
    }
    let widgetId = widget.attr('id');
    let chartData = {
        type: 'columnrange',
        inverted: true
    };
    chartData = prepareChartData(chartData, w, h);
    Highcharts.chart(widgetId, {
        chart: chartData,
        xAxis: {
            categories: categs
        },
        plotOptions: {
            columnrange: {
                dataLabels: {
                    enabled: true,
                    useHTML: true
                },
                point: {
                    events: {
                        click: handleChartClick
                    }
                }
            }
        },
        yAxis: {
            title: {
                text: yAxisTitle
            }
        },
        legend: {
            enabled: false
        },
        series: [{
            data: points
        }]

    });
}